import { object, string } from 'yup';

const matchFormSchema = object().shape({
  firstname: string().required('Please enter your first name.'),
  lastname: string().required('Please enter your last name.'),
});

export default matchFormSchema;
